import React from 'react';
import { TableRow, TableCell, MuiLink } from 'components/mui';
import { useNavigate } from 'react-router-dom';
import { ROUTE_CUSTOMERS, ROUTE_ADDRESS_MANAGEMENT, ROUTE_CASES } from 'constants/routerPath';
import { ShiftDetailRow } from 'containers/pages/payrollReport/types';

interface ShiftRowProps {
  row: ShiftDetailRow;
  reportType: 'guard' | 'consultant' | '';
}

const linkSx = { cursor: 'pointer', textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, fontSize: '0.85rem' };

function ShiftRow({ row, reportType }: ShiftRowProps) {
  const navigate = useNavigate();

  if (reportType === 'guard') {
    return (
      <TableRow sx={{ bgcolor: 'action.hover' }}>
        <TableCell />
        <TableCell sx={{ fontSize: '0.85rem' }}>{row.startTime}</TableCell>
        <TableCell sx={{ fontSize: '0.85rem' }}>{row.endTime}</TableCell>
        <TableCell sx={{ fontSize: '0.85rem' }}>
          {row.address ? (
            <MuiLink
              component="button"
              variant="body2"
              onClick={() => navigate(ROUTE_ADDRESS_MANAGEMENT)}
              sx={linkSx}
            >
              {row.address}
            </MuiLink>
          ) : (
            row.address
          )}
        </TableCell>
        <TableCell sx={{ fontSize: '0.85rem' }}>
          {row.customerName ? (
            <MuiLink
              component="button"
              variant="body2"
              onClick={() => navigate(ROUTE_CUSTOMERS)}
              sx={linkSx}
            >
              {row.customerName}
            </MuiLink>
          ) : (
            row.customerName
          )}
        </TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow sx={{ bgcolor: 'action.hover' }}>
      <TableCell />
      <TableCell sx={{ fontSize: '0.85rem' }}>{row.regularTime}</TableCell>
      <TableCell sx={{ fontSize: '0.85rem' }}>{row.overTime}</TableCell>
      <TableCell sx={{ fontSize: '0.85rem' }}>
        {row.caseTitle ? (
          <MuiLink
            component="button"
            variant="body2"
            onClick={() => navigate(ROUTE_CASES)}
            sx={linkSx}
          >
            {row.caseTitle}
          </MuiLink>
        ) : (
          row.caseTitle
        )}
      </TableCell>
      <TableCell sx={{ fontSize: '0.85rem' }}>
        {row.customerName ? (
          <MuiLink
            component="button"
            variant="body2"
            onClick={() => navigate(ROUTE_CUSTOMERS)}
            sx={linkSx}
          >
            {row.customerName}
          </MuiLink>
        ) : (
          row.customerName
        )}
      </TableCell>
    </TableRow>
  );
}

export default ShiftRow;
